module.exports = "/_next/static/images/tag-85afedd974dd031215b519fda1bc10ef.svg";